import React from 'react'

const CelebrityChefMenuDesktop = () => {
    return (
        <div>CelebrityChefMenuDesktop</div>
    )
}

export default CelebrityChefMenuDesktop